import React from 'react';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import EncodingDoc from '@splunk/dashboard-visualizations/common/EncodingDoc';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import BasicCode from '!!raw-loader!./examples/Basic';
import SortAxisLabelsCode from '!!raw-loader!./examples/SortAxisLabels';
import ShowBubbleLabelsNoneCode from '!!raw-loader!./examples/ShowBubbleLabelsNone';
import ShowBubbleLabelsMaxCode from '!!raw-loader!./examples/ShowBubbleLabelsMax';
import ShowBubbleLabelsAllCode from '!!raw-loader!./examples/ShowBubbleLabelsAll';
import BubbleRowScaleRowCode from '!!raw-loader!./examples/BubbleRowScaleRow';
import BubbleRowScaleGlobalCode from '!!raw-loader!./examples/BubbleRowScaleGlobal';
import BubbleScaleRadiusCode from '!!raw-loader!./examples/BubbleScaleRadius';
import BubbleScaleAreaCode from '!!raw-loader!./examples/BubbleScaleArea';
import ShowMaxValuePulsationCode from '!!raw-loader!./examples/ShowMaxValuePulsation';
import HideMaxValuePulsationCode from '!!raw-loader!./examples/HideMaxValuePulsation';
import DynamicSizingCode from '!!raw-loader!./examples/DynamicSizing';
import DynamicSizingMaxMinBubbleSizeSpecifiedCode from '!!raw-loader!./examples/DynamicSizingMaxMinBubbleSizeSpecified';
import FixedSizingCode from '!!raw-loader!./examples/FixedSizing';
import FixedSizingMaxMinBubbleRadiusSpecifiedCode from '!!raw-loader!./examples/FixedSizingMaxMinBubbleRadiusSpecified';
import ColorModeSequentialCode from '!!raw-loader!./examples/ColorModeSequential';
import BubbleColorCode from '!!raw-loader!./examples/BubbleColor';
import MinColorIntensitySpecifiedCode from '!!raw-loader!./examples/MinColorIntensitySpecified';
import ColorModeCategoricalCode from '!!raw-loader!./examples/ColorModeCategorical';
import ShowLegendCode from '!!raw-loader!./examples/ShowLegend';
import HideLegendCode from '!!raw-loader!./examples/HideLegend';
import CustomSeriesColorCode from '!!raw-loader!./examples/CustomSeriesColor';

import BasicExample from './examples/Basic';
import SortAxisLabelsExample from './examples/SortAxisLabels';
import ShowBubbleLabelsNoneExample from './examples/ShowBubbleLabelsNone';
import ShowBubbleLabelsMaxExample from './examples/ShowBubbleLabelsMax';
import ShowBubbleLabelsAllExample from './examples/ShowBubbleLabelsAll';
import BubbleRowScaleRowExample from './examples/BubbleRowScaleRow';
import BubbleRowScaleGlobalExample from './examples/BubbleRowScaleGlobal';
import BubbleScaleRadiusExample from './examples/BubbleScaleRadius';
import BubbleScaleAreaExample from './examples/BubbleScaleArea';
import ShowMaxValuePulsationExample from './examples/ShowMaxValuePulsation';
import HideMaxValuePulsationExample from './examples/HideMaxValuePulsation';
import DynamicSizingExample from './examples/DynamicSizing';
import DynamicSizingMaxMinBubbleSizeSpecifiedExample from './examples/DynamicSizingMaxMinBubbleSizeSpecified';
import FixedSizingExample from './examples/FixedSizing';
import FixedSizingMaxMinBubbleRadiusSpecifiedExample from './examples/FixedSizingMaxMinBubbleRadiusSpecified';
import ColorModeSequentialExample from './examples/ColorModeSequential';
import BubbleColorExample from './examples/BubbleColor';
import MinColorIntensitySpecifiedExample from './examples/MinColorIntensitySpecified';
import ColorModeCategoricalExample from './examples/ColorModeCategorical';
import ShowLegendExample from './examples/ShowLegend';
import HideLegendExample from './examples/HideLegend';
import CustomSeriesColorExample from './examples/CustomSeriesColor';

import doc from './definition';
import optionsSchema from '../optionsSchema';

export default () => (
    <VisualizationDocPage
        title="Punchcard"
        examplesSection={[
            <DocExample title="Basic Punchcard" key="basic" code={BasicCode} example={BasicExample} />,
            <DocExample
                title="Show Bubble Label - None"
                key="ShowBubbleLabelsNone"
                code={ShowBubbleLabelsNoneCode}
                example={ShowBubbleLabelsNoneExample}
            />,
            <DocExample
                title="Show Bubble Label - Max"
                key="ShowBubbleLabelsMax"
                code={ShowBubbleLabelsMaxCode}
                example={ShowBubbleLabelsMaxExample}
            />,
            <DocExample
                title="Show Bubble Label - All"
                key="ShowBubbleLabelsAll"
                code={ShowBubbleLabelsAllCode}
                example={ShowBubbleLabelsAllExample}
            />,
            <DocExample
                title="Bubble Row Scale - Row"
                key="bubbleRowScaleRow"
                code={BubbleRowScaleRowCode}
                example={BubbleRowScaleRowExample}
            />,
            <DocExample
                title="Bubble Row Scale - Global"
                key="bubbleRowScaleGlobal"
                code={BubbleRowScaleGlobalCode}
                example={BubbleRowScaleGlobalExample}
            />,
            <DocExample
                title="Bubble Scale - Radius"
                key="bubbleScaleRadius"
                code={BubbleScaleRadiusCode}
                example={BubbleScaleRadiusExample}
            />,
            <DocExample
                title="Bubble Scale - Area"
                key="bubbleScaleArea"
                code={BubbleScaleAreaCode}
                example={BubbleScaleAreaExample}
            />,
            <DocExample
                title="Show Max Value Pulsation"
                key="showMaxValuePulsation"
                code={ShowMaxValuePulsationCode}
                example={ShowMaxValuePulsationExample}
            />,
            <DocExample
                title="Hide Max Value Pulsation"
                key="hideMaxValuePulsation"
                code={HideMaxValuePulsationCode}
                example={HideMaxValuePulsationExample}
            />,
            <DocExample
                title="Dynamic Bubble Sizing"
                key="dynamicSizing"
                code={DynamicSizingCode}
                example={DynamicSizingExample}
            />,
            <DocExample
                title="Fixed Bubble Sizing"
                key="fixedSizingCode"
                code={FixedSizingCode}
                example={FixedSizingExample}
            />,
            <DocExample
                title="Max Bubble Size - 125%, Min Bubble Size - 15%"
                key="dynamicSizingMaxMinBubbleSizeSpecified"
                code={DynamicSizingMaxMinBubbleSizeSpecifiedCode}
                example={DynamicSizingMaxMinBubbleSizeSpecifiedExample}
            />,
            <DocExample
                title="Max Bubble Radius - 30px, Min Bubble Radius - 5px"
                key="fixedSizingMaxMinBubbleRadiusSpecified"
                code={FixedSizingMaxMinBubbleRadiusSpecifiedCode}
                example={FixedSizingMaxMinBubbleRadiusSpecifiedExample}
            />,
            <DocExample
                title="Color Mode - Sequential"
                key="colorModeSequential"
                code={ColorModeSequentialCode}
                example={ColorModeSequentialExample}
            />,
            <DocExample
                title="Bubble Color - Red"
                key="bubbleColor"
                code={BubbleColorCode}
                example={BubbleColorExample}
            />,
            <DocExample
                title="Min Color Intensity - 1%"
                key="minColorIntensitySpecified"
                code={MinColorIntensitySpecifiedCode}
                example={MinColorIntensitySpecifiedExample}
            />,
            <DocExample
                title="Color Mode - Categorical"
                key="colorModeCategorical"
                code={ColorModeCategoricalCode}
                example={ColorModeCategoricalExample}
            />,
            <DocExample
                title="Show Legend"
                key="showLegend"
                code={ShowLegendCode}
                example={ShowLegendExample}
            />,
            <DocExample
                title="Hide Legend"
                key="hideLegend"
                code={HideLegendCode}
                example={HideLegendExample}
            />,
            <DocExample
                title="Series Color: Red, Blue, Green, Orange, Cyan"
                key="customSeriesColor"
                code={CustomSeriesColorCode}
                example={CustomSeriesColorExample}
            />,
            <DocExample
                title="Sort Axis Labels"
                key="sortAxisLabels"
                code={SortAxisLabelsCode}
                example={SortAxisLabelsExample}
            />,
        ]}
        encodingSection={<EncodingDoc encoding={doc.encoding} />}
        optionSection={<OptionsDoc options={optionsSchema} />}
    />
);
